export const GET_CICLO_ELECTIVOS_REQUEST = 'GET_CICLO_ELECTIVOS_REQUEST'
export const GET_CICLO_ELECTIVO = 'GET_CICLO_ELECTIVO'
export const GET_CICLO_ELECTIVOS = 'GET_CICLO_ELECTIVOS'
export const ADD_CICLO_ELECTIVO = 'ADD_CICLO_ELECTIVO'
export const DELETE_CICLO_ELECTIVO = 'DELETE_CICLO_ELECTIVO'
export const EDIT_CICLO_ELECTIVO = 'EDIT_CICLO_ELECTIVO'
export const CICLO_ELECTIVO_FAIL = 'CICLO_ELECTIVO_FAIL'
